import { trackEvent } from "./titanAnalytics";

export const TRACKING_ERROR_CODES = {
  UNKNOWN_ERROR: "000",
  SCOPELY_AUTH_RESULT_CATCH: "6000",
  SCOPELY_IS_NOT_SUCCESSFUL: "6001",
  FACEBOOK_RESPONSE_ERROR: "7000",
  FACEBOOK_COMPONENT_ON_FAILURE: "7001",
  FAST_LOGIN_DATA_IS_NOT_SUCCESS: "8000",
  FAST_LOGIN_FETCH_CATCH: "8001",
  ME_SESSIONS_NOT_DATA: "9000",
  ME_SESSIONS_FETCH_CATCH: "9001",
};

export const TRACKING_ACTIONS = {
  LOGIN_SUCCESSFULL: 0,
  LOGIN_FAILED: 1,
  LOGIN_ABANDONED: 2,
  LOG_OUT: 3,
};
export const TRACKING_TYPES = {
  FAST_LOGIN: 0,
  FACEBOOK: 1,
  SCOPELY_ID: 2,
};

const loginFlowActions = ["login_sucessfull", "login_failed", "login_abandoned", "log_out"];
const loginFlowTypes = ["fail_fast_url", "Facebook", "ScopelyId"];

interface TLoginAnalyticsTracking {
  type: number;
  action: number;
  errorCode?: string;
}

export const loginAnalyticsTracking = ({ type, action, errorCode }: TLoginAnalyticsTracking) => {
  const loginFlowParams = {
    login_type: loginFlowTypes[type],
    action: loginFlowActions[action],
    ...(errorCode && { error_code: Number(errorCode) }),
  };

  trackEvent("sys.login_flow", loginFlowParams);
};

interface TSysConnectArgs {
  type: string;
  errorCode?: string;
  params?: {
    coins: number;
    diamonds: number;
    energy: number;
    hints: number;
    ssoId: string
  }
}

export const trackSysConnect = ({ type, params, errorCode }: TSysConnectArgs) => {
  const sysConnectTypes = {
    fastlogin: "Fastlogin",
    facebook:"facebook",
    scopely: "ScopelyId"
  };
  let connectionType = sysConnectTypes.scopely;
  if (type?.toLowerCase()?.includes("facebook")){
    connectionType = sysConnectTypes.facebook;
  } else if (type?.toLowerCase()?.includes("scopely")) {
    connectionType = sysConnectTypes.scopely;
  } else {
    connectionType = sysConnectTypes.fastlogin;
  }
  const connectAction = errorCode ? "login_failed" : "login";

  trackEvent("sys.connect", {
    action: connectAction,
    connection_type: connectionType,
    context: "DeepLink",
    event_source: "web_portal",
    platform: "web",
    coins_balance: params?.coins || 0,
    diamonds_balance: params?.diamonds || 0,
    energy_balance: params?.energy || 0,
    hints_balance: params?.hints || 0,
    id: params?.ssoId || null
  });
}
